import React from "react";
import { useTranslation } from "react-i18next";

import { Identifiable, ProjectResource, Resource as R } from "@planzone/dto";
import { Props } from "./types";
import { Resource } from "./resource";
import { ResourceForm } from "./resourceForm";
import styles from "./styles.scss";

function ResourcesList(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.resourcesList}>
      <h3 className={styles.title}>
        {t("editResourceGroup.resourcesList.title")}
      </h3>
      <div className={styles.resourceForm}>
        <ResourceForm
          group={props.group}
          project={props.project}
          resources={props.resources}
        />
      </div>
      <div className={styles.resources}>
        {props.resources.map((resource) => (
          <div className={styles.resource}>
            {props.group.resourceType === "project" ? (
              <Resource
                key={resource.uuid}
                projectResource={resource as Identifiable<ProjectResource>}
                group={props.group}
                project={props.project}
              />
            ) : (
              <Resource
                key={resource.uuid}
                resource={resource as Identifiable<R>}
                group={props.group}
                project={props.project}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export { ResourcesList };
